import { useState } from "react";
import { changePassword } from "../../services/profileService";

export default function ChangePassword() {
  const [form, setForm] = useState({
    oldPass: "",
    newPass: "",
    confirmPass: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.oldPass || !form.newPass || !form.confirmPass) {
      alert("All fields are required.");
      return;
    }

    if (form.newPass !== form.confirmPass) {
      alert("New password and confirm password must match.");
      return;
    }

    setLoading(true);

    try {
      const data = await changePassword(form);

      if (data.status) {
        alert("Password changed successfully!");
        setForm({
          oldPass: "",
          newPass: "",
          confirmPass: "",
        });
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }

    setLoading(false);
  };

  return (
    <div className="profile-card">
      <h3>Change Password</h3>

      <form onSubmit={handleSubmit} className="password-form">
        <input
          type="password"
          name="oldPass"
          placeholder="Old Password"
          value={form.oldPass}
          onChange={handleChange}
        />

        <input
          type="password"
          name="newPass"
          placeholder="New Password"
          value={form.newPass}
          onChange={handleChange}
        />

        <input
          type="password"
          name="confirmPass"
          placeholder="Confirm Password"
          value={form.confirmPass}
          onChange={handleChange}
        />

        <button type="submit" disabled={loading}>
          {loading ? "Updating..." : "Update Password"}
        </button>
      </form>
    </div>
  );
}
